import { useEffect, useState } from "react";
import { api, formatError } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { toast } from "sonner";
import { Plus } from "lucide-react";

const CATEGORIES = ["sources","stages","dispositions","lost_reasons","visit_statuses","booking_statuses","cp_categories","inventory_statuses","departments","designations"];

export default function Masters() {
  const [cat, setCat] = useState("sources");
  const [items, setItems] = useState([]);
  const [val, setVal] = useState("");
  const load = () => api.get(`/masters/${cat}`).then(r => setItems(r.data));
  useEffect(() => { load(); }, [cat]);
  const add = async () => {
    if (!val.trim()) return;
    try { await api.post("/masters", { category: cat, value: val.toLowerCase().replace(/\s+/g,"_"), label: val }); setVal(""); toast.success("Added"); load(); }
    catch (e) { toast.error(formatError(e.response?.data?.detail) || e.message); }
  };
  return (
    <div className="space-y-6 animate-in">
      <div>
        <div className="text-[11px] uppercase tracking-[0.3em] text-muted-foreground">Configuration</div>
        <h1 className="font-serif-display text-3xl">Masters</h1>
        <p className="text-sm text-muted-foreground mt-1">Configure sources, stages, dispositions and other pick-lists without code changes.</p>
      </div>
      <Tabs value={cat} onValueChange={setCat}>
        <TabsList className="flex-wrap h-auto justify-start">
          {CATEGORIES.map(c => <TabsTrigger key={c} value={c} data-testid={`master-tab-${c}`}>{c.replace(/_/g," ")}</TabsTrigger>)}
        </TabsList>
        {CATEGORIES.map(c => (
          <TabsContent key={c} value={c}>
            <Card className="p-4">
              <div className="flex gap-2 mb-4">
                <Input placeholder={`Add new ${c.replace(/_/g," ")}`} value={val} onChange={e => setVal(e.target.value)} data-testid="master-value-input"/>
                <Button onClick={add} data-testid="master-add-btn"><Plus size={14} className="mr-1"/> Add</Button>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                {items.map(i => (
                  <div key={i.id} className="border border-border rounded p-2 text-sm flex justify-between items-center">
                    <span>{i.label || i.value}</span>
                    <span className={`text-[10px] px-2 py-0.5 rounded border ${i.active ? "border-emerald-300 text-emerald-700" : "border-rose-300 text-rose-700"}`}>{i.active ? "Active" : "Off"}</span>
                  </div>
                ))}
              </div>
            </Card>
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
